import stripePayoutListStore from '@modules/stripe/stripe-payout/stripe-payout-list-store';

export default {
  namespaced: true,

  modules: {
    list: stripePayoutListStore,
  },
};
